import { SIMPLE_RULE_1, SIMPLE_RULE_PROPERTY_INFO_1, SIMPLE_RULE_SET_1 } from './fixtures';
import type { RulePropertyInfo } from './types';
import type {
  PartnerRule,
  PartnerRuleCreate,
  PartnerRuleSet,
  PartnerRuleSetCreate,
  PartnerRuleSetUpdate,
  PartnerRuleUpdate,
} from '@shipium-corp/shipium-ts-types';

export class RuleSetServiceV2Mock {
  public async fetchRuleSet(populateRules = true): Promise<PartnerRuleSet[]> {
    return Promise.resolve([SIMPLE_RULE_SET_1]);
  }

  public async createRuleSet(payload: PartnerRuleSetCreate): Promise<PartnerRuleSet> {
    return Promise.resolve(SIMPLE_RULE_SET_1);
  }

  public async fetchRuleSetById(ruleSetId: string): Promise<PartnerRuleSet> {
    return Promise.resolve(SIMPLE_RULE_SET_1);
  }

  public async updateRuleSet(ruleSetId: string, payload: PartnerRuleSetUpdate): Promise<PartnerRuleSet> {
    return Promise.resolve(SIMPLE_RULE_SET_1);
  }
  //#endregion

  //#region Rule Service Methods
  public async fetchRules(): Promise<PartnerRule[]> {
    return Promise.resolve([SIMPLE_RULE_1]);
  }

  public async createRule(payload: PartnerRuleCreate): Promise<PartnerRule> {
    return Promise.resolve(SIMPLE_RULE_1);
  }

  public async fetchRulePropertyInfos(): Promise<RulePropertyInfo[]> {
    return Promise.resolve([SIMPLE_RULE_PROPERTY_INFO_1]);
  }

  public async fetchRuleById(ruleId: string): Promise<PartnerRule> {
    return Promise.resolve(SIMPLE_RULE_1);
  }

  public async updateRule({ ruleId, payload }: { ruleId: string; payload: PartnerRuleUpdate }): Promise<PartnerRule> {
    return Promise.resolve(SIMPLE_RULE_1);
  }
}

export default RuleSetServiceV2Mock;
